import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER_COLS } from '../data/site';

const V2Footer = () => (
  <footer className="border-t border-[#dde5f3] bg-white">
    <div className="mx-auto max-w-7xl px-6 pt-16">
      <div className="grid grid-cols-2 gap-10 pb-16 md:grid-cols-6">
        <div className="col-span-2">
          <Link to="/v2" className="flex items-center gap-2.5">
            <img src="/assets/alogo.png" alt="Asha" className="h-8 w-8 rounded-lg" />
            <span className="v2-display text-[24px] font-semibold tracking-tight text-[#0a1633]">asha</span>
          </Link>
          <p className="mt-4 max-w-xs text-[14px] leading-relaxed text-[#7c89a8]">
            The first AI-native operating system for dental. One platform, 10+ software products,
            and a 20+ agent AI workforce that runs the busywork — so your team can run the practice.
          </p>
          <div className="v2-mono mt-6 flex flex-wrap gap-x-4 gap-y-1 text-[11px] font-medium uppercase tracking-[0.12em] text-[#7c89a8]">
            <span>HIPAA compliant</span>
            <span aria-hidden className="text-[#a8bcf0]">+</span>
            <span>Cloud native</span>
            <span aria-hidden className="text-[#a8bcf0]">+</span>
            <span>24/7</span>
          </div>
        </div>
        {FOOTER_COLS.map((col) => (
          <div key={col.title}>
            <div className="v2-mono mb-4 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#1a46e5]">
              {col.title}
            </div>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-[14px] font-medium text-[#3f4d6e] transition-colors hover:text-[#1a46e5]">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="flex flex-col items-start justify-between gap-4 border-t border-[#dde5f3] py-7 text-[13px] text-[#7c89a8] md:flex-row md:items-center">
        <span>© {new Date().getFullYear()} Asha Health, Inc. All rights reserved.</span>
        <span className="v2-mono text-[11px] font-medium uppercase tracking-[0.14em]">
          the operating system for dental
        </span>
      </div>
    </div>

    {/* oversized wordmark sign-off */}
    <div aria-hidden className="select-none overflow-hidden">
      <div className="v2-display mx-auto max-w-7xl px-6 text-center text-[24vw] font-semibold leading-[0.78] text-[#e2eafc] md:text-[19rem]">
        asha
      </div>
    </div>
  </footer>
);

export default V2Footer;
